import { render } from "./CartIndex.vue?vue&type=template&id=874c0466&scoped=true"
import script from "./CartIndex.vue?vue&type=script&lang=js"
export * from "./CartIndex.vue?vue&type=script&lang=js"

import "./CartIndex.vue?vue&type=style&index=0&id=874c0466&lang=scss&scoped=true"
import "./CartIndex.vue?vue&type=style&index=1&id=874c0466&lang=scss"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-874c0466"]])

export default __exports__